<template>
    <div id="app">
        <app-header />
        <main>
            <router-view />
            <app-footer />
        </main>
    </div>
</template>

<script>
import AppHeader from './components/header.vue'
import AppFooter from './components/footer.vue'
import { scrollBehavior } from './plugins/router-scroll-behavior'


export default {
  name: 'app',
  components: {
      AppHeader,
      AppFooter
  },
  mounted(){
      // NOTE: we trigger scrollBehavior here cause it is not called on page load, see https://github.com/vuejs/vue-router/issues/2358
      scrollBehavior(this.$route);
  }
}
</script>

<style lang="scss" src="./main.scss"></style>
